

function SendData (socket,command,data) {
  const id=localStorage.getItem ('id');
  const phone=localStorage.getItem ('phone');
  const boards=JSON.parse(localStorage.getItem ('boards'));
  const select_board=localStorage.getItem ('select_board');
  if (id!=null)
    data.myId=id;
  if (phone!=null)
    data.myPhone=phone;
  if (boards!=null && boards[select_board]!=null && boards[select_board].id!=null)
    data.myBoard=boards[select_board].id;
  socket.emit (command,data)
}

export default SendData;
